import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const BinLocationsColumns = [
    {
        dataField: 'Bin',
        caption: 'Bin',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.sm0,
        fixed: true,
        allowSorting: true,
        allowEditing: false,
    },
    {
        dataField: 'BinType',
        caption: 'Bin type',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.sm0,
        fixed: true,
        allowSorting: true,
        allowEditing: false,
    },
    {
        dataField: 'Quantity',
        caption: 'Quantity',
        minWidth: COLUMN_SIZE.sm1,
        width: COLUMN_SIZE.sm0,
        fixed: true,
        allowSorting: true,
        allowEditing: true,
    },
];
